import axios from 'axios';
import type { CartItem } from 'types';

const shopifyMergeToCard = async (newItems: CartItem[]) => {
  const cardItems = newItems.map((item) => ({
    id: item.variantId,
    quantity: item.qty
  }));
  await axios.post('/cart/add.js', {
    items: cardItems
  });
};
export default shopifyMergeToCard;
